import React, {Component} from 'react';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';

export default class MyTooltip extends Component {
  render() {
    return (
      <span className="mytooltip">
        <Tooltip overlay={<span className="mytooltip-overlay">{this.props.text}</span>}><div className="glyphicon">&#xe085;</div></Tooltip>
      </span>
    )
  }
}



// WEBPACK FOOTER //
// ./src/MyTooltip.js